module.exports = __webpack_public_path__ + "static/media/harvard_logo.30617e63.svg";